import { getBackendErrors, getErrorMessage } from "api/errors";
import { useMember } from "api/members";
import { ConfirmationModal } from "components/Tooltips/ConfirmationModal";
import { useNotifications } from "contexts/Toast/ToastProvider";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { Coupon } from "types/rewards";
import { backendErrors } from "utilities/backendErrors";
import ChangeRedemptionStatusModal from "./ChangeRedemptionStatusModal";
import CouponDetailsModal from "./CouponDetailsModal";

interface RewardRedemptionModalsProps {
  close: () => void;
  open: boolean;
  selectedModal?: {
    issuedCoupon?: Coupon;
    issuedReward?: string;
    memberId?: string;
    mode: number;
  };
}
export enum ModalMode {
  ChangeStatus,
  Coupon,
  RedeemAssignedCoupon,
  ReissueAssignedCoupon,
}
export function RewardRedemptionModals({
  close,
  open,
  selectedModal,
}: RewardRedemptionModalsProps) {
  const { message } = useMessage();
  const { notify } = useNotifications();
  const { redeemAssignedCoupon, reissueAssignedCoupon } = useMember();
  const [errors, setErrors] = useState(null);

  return (
    <>
      {selectedModal?.issuedReward &&
        selectedModal?.mode === ModalMode.ChangeStatus && (
          <ChangeRedemptionStatusModal
            closeModal={close}
            open={open}
            redemptionId={selectedModal.issuedReward}
          />
        )}
      {selectedModal?.mode === ModalMode.Coupon && (
        <CouponDetailsModal
          closeModal={close}
          open={open}
          couponData={selectedModal.issuedCoupon}
        />
      )}
      {selectedModal?.issuedCoupon &&
        selectedModal?.mode === ModalMode.ReissueAssignedCoupon && (
          <ConfirmationModal
            action={async () => {
              try {
                const response = await reissueAssignedCoupon(
                  selectedModal.memberId!,
                  selectedModal.issuedCoupon?.code!,
                );
                if (response) {
                  close();
                  notify(
                    message({
                      id: "couponSuccesfullyMarkedAsUnused",
                    }),
                  );
                }
              } catch (exception) {
                notify(getErrorMessage(exception));
              }
            }}
            close={close}
            header="markAsUnused"
            info="markAsUnusedInfo"
            open={open}
            data-test-id="mark-as-unused"
          />
        )}
      {selectedModal?.issuedCoupon &&
        selectedModal?.mode === ModalMode.RedeemAssignedCoupon && (
          <ConfirmationModal
            action={async () => {
              try {
                const response = await redeemAssignedCoupon(
                  selectedModal.memberId!,
                  selectedModal.issuedCoupon?.code!,
                );
                if (response) {
                  close();
                  notify(message({ id: "couponSuccesfullyMarkedAsUsed" }));
                }
              } catch (exception) {
                notify(getErrorMessage(exception));
                setErrors(backendErrors(getBackendErrors(exception)));
              }
            }}
            close={() => {
              close();
              setErrors(null);
            }}
            header="markAsUsed"
            info="markAsUsedInfo"
            open={open}
            errorInfo={errors?.[""]}
            data-test-id="mark-as-used"
          />
        )}
    </>
  );
}
